import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import OnDOMReady from "shared/util/OnDOMReady";
import ClientStats from "shared/util/ClientStats";
import Breadcrumb from "shared/util/Breadcrumb";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";

import boosts, { toggleVisible } from "ducks/boosts";

import boostsAnalytics from "analytics/boosts";
import { markExperiments } from "shared/util/Experiment";

import Boosts from "apps/boosts";


const appendRootElement = () => {
	const rootElementId = "boosts_modal";
	const previousModal = document.getElementById(rootElementId);

	if (previousModal) {
		previousModal.remove();
	}

	const rootElement = window.document.createElement("div");
	rootElement.id = rootElementId;

	window.document.body.appendChild(rootElement);

	return rootElement;
};

const store = addToGlobalStore({ boosts });


addToGlobalAnalyticsMiddleware({
	boosts: boostsAnalytics,
});

export const ReactBoosts = {
	init() {
		render(
			(
				<Provider store={store}>
					<Boosts />
				</Provider>
			),
			appendRootElement(),
		);
	},

	open({ cameFrom, promoDesign } = {}) {
		ClientStats.update("desktop - boostsubs - modal - opened");
		ClientStats.update({
			statname: "purchases - platform:desktop - product:boost - packages displayed",
			unique: true,
		});

		if (cameFrom) {
			Breadcrumb.set({
				key: "cf",
				value: cameFrom,
			});
		}

		if (promoDesign) {
			Breadcrumb.set({
				key: "pd",
				value: promoDesign,
			});
		}

		markExperiments(["PRICE_TEST_IS306_V2"]);
		store.dispatch(toggleVisible(true, promoDesign));
	},

	close() {
		store.dispatch(toggleVisible(false));
	},
};

OnDOMReady(() => ReactBoosts.init());



// WEBPACK FOOTER //
// ./src/features/boosts/index.js